import { module } from 'modujs';
import Flickity from 'flickity';

export default class Slider extends module {

    static get settings() {
        return {
            DISABLED_CLASS: 'is-disabled'
        }
    }

    constructor(m) {
        super(m);

        this.$container = this.$('container')[0]
        this.$prev = this.$('prev')[0]
        this.$next = this.$('next')[0]

        this.events = {
            click: {
                prev: 'previous',
                next: 'next',
            }
        }
    }

    init() {

        this.flkty = new Flickity(this.$container, {
            cellAlign: 'left',
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            groupCells: true,
        })

        this.totalSlides = this.flkty.slides.length

        this.handleNav()

        this.flkty.on('select', this.handleNav.bind(this))
    }

    previous() {
        this.flkty.previous()
    }

    next() {
        this.flkty.next()
    }

    handleNav() {
        const currentSlide = this.flkty.selectedIndex

        if(currentSlide > 0) {
            this.$prev.classList.remove(Slider.settings.DISABLED_CLASS)
        } else {
            this.$prev.classList.add(Slider.settings.DISABLED_CLASS)
        }

        if(currentSlide < this.totalSlides - 1) {
            this.$next.classList.remove(Slider.settings.DISABLED_CLASS)
        } else {
            this.$next.classList.add(Slider.settings.DISABLED_CLASS)
        }
    }

    destroy() {
        if(this.flkty) {
            this.flkty.destroy()
        }
    }
}
